module.exports = __webpack_public_path__ + "img/logo_asahi.d2f1c8bb.png";